var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Menu } from '@base-ui/react/menu';
import CalendarWithContext from 'modules/calendar';
import { useMenuContext } from './useMenuContext';
export function MenuCalendar(props) {
    const { onChange, closeOnClick = true } = props, rest = __rest(props, ["onChange", "closeOnClick"]);
    const { close } = useMenuContext();
    const handleChange = (date) => __awaiter(this, void 0, void 0, function* () {
        if (onChange) {
            yield onChange(date);
        }
        if (closeOnClick) {
            close();
        }
    });
    return <Menu.Item closeOnClick={false} render={<CalendarWithContext {...rest} onChange={handleChange}/>}/>;
}
